import { Card, CardStatus, LockReasonTypeCode, LockTypeCode } from '../data';

export function isVerified(card: Card): boolean {
  return card.status === CardStatus.Verified || card.status === CardStatus.Reissued;
}

export function isVerifiable(card: Card | null): boolean {
  return (
    card?.status === CardStatus.PendingVerification ||
    card?.status === CardStatus.ReissuedPendingVerification ||
    card?.status === CardStatus.AutoReissuedPendingVerification
  );
}

export function isUnlocked(card: Card): boolean {
  return card.lockTypeCode === LockTypeCode.Unlocked;
}

export function isLocked(card: Card): boolean {
  return !isUnlocked(card);
}

export function isSystemLocked(card: Card): boolean {
  return card.lockTypeCode === LockTypeCode.SystemLocked;
}

export function isCustomerLocked(card: Card): boolean {
  return card.lockTypeCode === LockTypeCode.CustomerLocked;
}

export function isUserUnlockable(card: Card): boolean {
  return card.lockTypeCode === LockTypeCode.CustomerLocked && card.lockReasonTypeCode === LockReasonTypeCode.Temporary;
}

export function isReissuedPending(card: Card): boolean {
  return card.status === CardStatus.ReissuedPendingVerification;
}

export function isExpiringReissue(card: Card | null): boolean {
  return (
    card?.status === CardStatus.AutoReissuedPendingVerification ||
    card?.status === CardStatus.ReissuedPendingVerification
  );
}

export function isDenied(card: Card): boolean {
  return card.status === CardStatus.Denied;
}
